import { useStaticQuery, graphql } from 'gatsby';
import { usePageContext } from 'gatsby-theme-thepuzzlers-core';

export const useFeaturesPageContent = () => {
  const { locale } = usePageContext();

  const data = useStaticQuery(graphql`
    query {
      en: featuresPageContentJson {
        header {
          description
          headline
        }
        discover {
          feature_list {
            description
            title
          }
          headline {
            html
          }
        }
        interact {
          feature_list {
            description
            title
          }
          headline {
            html
          }
        }
        sell {
          feature_list {
            description
            title
          }
          headline {
            html
          }
        }
      }
      de: deFeaturesPageContentJson {
        header {
          description
          headline
        }
        discover {
          feature_list {
            description
            title
          }
          headline {
            html
          }
        }
        interact {
          feature_list {
            description
            title
          }
          headline {
            html
          }
        }
        sell {
          feature_list {
            description
            title
          }
          headline {
            html
          }
        }
      }
    }
  `);

  return data[locale];
};
